// Styles for PrivacyRightsWrapper go here.
import styled, { createGlobalStyle } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledPrivacyRightsMainContainer = styled.div`
  background-color: ${baseVariables.color['base20']};
  margin: ${toRem(32)} auto ${toRem(60)};
  position: relative;

  .display-name {
    text-align: center;
  }

  @media ${baseVariables.mediaQuery.md} {
    margin-top: ${toRem(-50)};
  }
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
  border-radius: ${toRem(14)};
  padding: ${toRem(32)} ${toRem(24)};
  @media screen and (max-width: ${toRem(576)}) {
    padding: ${toRem(32)} 0;
    width: 90%;
  }

  .text-center: {
    text-align: center;
  }
  .tab-disable-border {
    box-shadow: none;
    width: ${toRem(327)} !important;
    max-width: 90%;
    .tab-height {
      height: ${toRem(40)};
    }
  }
  .privacy-statement {
    text-align: center;
    padding: 0 1.5625rem;
    margin: 0 auto;
  }

  .states-dropdown {
    width: 90%;
    margin: ${toRem(24)} auto;
    @media ${baseVariables.mediaQuery.md} {
      width: 40%;
    }
    @media ${baseVariables.mediaQuery.lg} {
      width: 30%;
    }
  }
  .userName-loader {
    width: ${toRem(300)};
    height: ${toRem(48)};
    margin: 0 auto;
  }
  .privacy-subHeading-loader {
    width: 50%;
    height: ${toRem(200)};
    margin: ${toRem(20)} auto;
  }
  .privacy-rights-loader {
    width: 95%;
    height: ${toRem(200)};
    margin: 0 auto;
  }
`;

export const StyledPrivacyRightsFormSection = styled.div`
  .form-container {
    @media screen and (max-width: ${toRem(1200)}) {
      flex-wrap: wrap;
    }
    .form-element {
      max-width: ${toRem(635)};
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: stretch;
      padding: ${toRem(24)};
      flex-shrink: 1;
      border-radius: ${toRem(16)};
      background: var(--Colors-neutral-10, #f4f4f4);
      .m-input-text-field {
        width: 66%;
        @media screen and (max-width: ${toRem(720)}) {
          width: 100%;
        }
        height: ${toRem(52)};
        background-color: white;
      }
    }
  }
  button {
    @media screen and (max-width: ${toRem(768)}) {
      &.sbt-btn {
        margin: ${toRem(4)} 0 ${toRem(16)} 0;
      }
    }
    &.disable-btn {
      background-color: #c4c4c4;
      min-width: ${toRem(248)};
      cursor: no-drop;
    }
  }
`;

export const GlobalStyles = createGlobalStyle`
  body {
    background-color: #f4f4f4 !important;
  }
`;
